import AbstractClass from './GenerateMemberCardsAbstractServices';

import { AwaitResponse } from '../../utils/MockUtils';

export default class GenerateMemberCardsServices extends AbstractClass {
  /**
   * Return a mock data of postal address and last ordered membership cards' issue date and number of cards ordered
   */
  static getLastOrder() {
    return AwaitResponse({
      issueDate: '2023-10-20',
      numberOfCards: 3,
    });
  }

  static getPostalAddress() {
    return AwaitResponse({
      addressList: [
        {
          preferredAddress: 'M',
          keepPrivate: false,
          addressLine1: 'Level 22/8 Exhibition Street',
          addressLine2: '',
          addressLine3: '',
          suburb: 'Melbourne',
          state: 'VIC',
          postcode: '3000',
          country: 'AUS',
        },
      ],
    });
  }

  static getReferenceData() {
    return AwaitResponse({
      memberCardInformationText: {
        informationText:
          '<p>Your member card identifies you as a member of a special community &ndash; the Defence Health family. Use it to claim on-the spot at most extras providers. You&rsquo;ll also need to present your card if you or someone covered by your policy goes to hospital. So keep it safe.<br />\r\n<br />\r\nRequests for new member cards will be sent to your nominated postal address. Please make sure that it is up to date before you request a new card. If you haven&rsquo;t nominated one, the postal address will default to the policy holder&rsquo;s postal address, or residential address if a postal address is unavailable.<br />\r\n<br />\r\nOrder today and you should receive the requested cards in the next 10 business days.</p>\r\n',
      },
      confirmationInformationText: {
        informationText:
          '<h2>Thanks, your member card request was successful</h2>\r\n\r\n<p>Your cards will be sent to your nominated postal address. You should receive them in the next 10 business days.</p>\r\n\r\n<p>Keep your card with you for instant recognition and convenient on-the-spot claims at most extras providers. You&rsquo;ll also need to present your card if you or someone covered by your policy goes to hospital. So keep it safe.</p>\r\n',
      },
      relatedArticle1: {
        heading: 'Augmented reality and team-building',
        toUrl: '/Support/Health-HQ/2019/November/Augmented-Reality-and-team-building',
        imageUrl: '~/getmedia/cac3ef3b-733c-417e-9b23-36464193573f/blogimage1.jpg?width=1024&height=682&ext=.jpg',
        imageAltText: 'Augmented Reality and team-building',
        tag: 'Health',
        listedTime: '2019-10-28T00:00:00',
      },
      relatedArticle2: null,
      relatedArticle3: null,
    });
  }

  /**
   * Return a mock api status code
   */
  static submitNewCardOrder() {
    return AwaitResponse({ orderSuccessFlag: true });
  }
}
